/** @format */

import Page from "../../components/Page";
import {
  Card,
  CircularProgress,
  Container,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import Iconify from "../../components/Iconify";
import UserForm from "./UserForm";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import User from "../../dao/User";
import swal from "../../reusables/CustomSwal";
import * as Yup from "yup";
import { useFormik } from "formik";

export default function ProfileEdit() {
  const navigate = useNavigate();
  const [isDataLoading, setIsDataLoading] = useState(true);
  const [userDetails, setUserDetails] = useState({});

  const getUserDetails = async () => {
    try {
      let result = await User.getSelf();
      setUserDetails({ ...result.profile });
      setIsDataLoading(false);
    } catch (e) {
      let errorMessage = "An error has occurred. Please try again.";
      let confirmResult = await swal.fire({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "Ok",
      });
      if (confirmResult.isConfirmed || confirmResult.isDismissed) navigate(-1);
    }
  };
  useEffect(() => {
    getUserDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const editProfile = async (values) => {
    let body = values;
    delete body.email;

    let popupResult = await swal.fire({
      title: "Confirm",
      text: "Are you sure to save this user?",
      icon: "question",
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: "Save",
    });

    if (popupResult.isConfirmed) {
      try {
        let queryResult = await User.updateSelf(body);
        await swal.fire({
          title: "Success",
          text: "User data is saved.",
          icon: "success",
          confirmButtonText: "Go back",
        });
        localStorage.name = `${queryResult.first_name} ${queryResult.last_name}`;
        navigate(-1);
      } catch (e) {
        console.log(e);
        let errorMessage = "An error has occurred. Please try again later.";
        if (e.code === "INVALID_EMAIL" || e.code === "MISSING_INFO")
          errorMessage = "Please re-check the user data.";
        await swal.fire({
          title: "Error",
          text: errorMessage,
          icon: "error",
        });
      }
    }
  };

  const initialValues = {
    first_name: userDetails.first_name,
    last_name: userDetails.last_name,
    job_title: userDetails.job_title,
    email: userDetails.email,
    phone_number: userDetails.phone_number,
  };

  const EditSchema = Yup.object().shape({
    first_name: Yup.string().required("First name is required."),
    last_name: Yup.string(),
    job_title: Yup.string().required("Job Title is required."),
    email: Yup.string()
      .email("Email must be a valid email address.")
      .required("Email is required."),
    phone_number: Yup.string().required("Phone number is required."),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: EditSchema,
    onSubmit: editProfile,
  });

  return (
    <Page title="Edit Profile">
      <Container>
        <Stack spacing={2} direction="row" sx={{ mb: 4 }}>
          <IconButton
            sx={{ p: 0, height: "100%", backgroundColor: "white" }}
            onClick={() => navigate(-1)}
          >
            <Iconify icon="eva:arrow-ios-back-fill" width={22} height={22} />
          </IconButton>
          <Typography variant="h4">Edit Profile</Typography>
        </Stack>
        <Card sx={{ p: 4 }}>
          {isDataLoading ? (
            <Stack alignItems="center">
              <CircularProgress />
            </Stack>
          ) : (
            <UserForm formik={formik} mode="profile" />
          )}
        </Card>
      </Container>
    </Page>
  );
}
